import { Badge, Grid, Image, Stack, Text } from "@mantine/core";

import Lock from "../icons/Lock.png";
import { getBadgeIconByChallengeType, getBadgeText } from "../utils/getBadgeDetails";
import classes from "./TrophyCaseBadges.module.css";

interface TrophyCaseStatsItem {
    challengeType: string;
    totalCount: number;
    successfulCount: number;
}

interface TrophyCaseBadgesProps {
    trophyCaseStats: TrophyCaseStatsItem[];
}

export function TrophyCaseBadges({ trophyCaseStats }: TrophyCaseBadgesProps) {
    return (
        <Grid pt="0.875rem" pl="sm" pr="sm" className={classes.trophyCaseCard}>
            {trophyCaseStats
                .filter((stat) => stat.totalCount > 0)
                .toSorted((a, b) => b.successfulCount - a.successfulCount)
                .map((stat, index) => {
                    const isDisabled = stat.successfulCount === 0;
                    return (
                        <Grid.Col key={index} span={4}>
                            <Stack key={index} align="center" gap="0.25rem" pb="0.875rem">
                                <Image
                                    data-testid="badge-type"
                                    src={getBadgeIconByChallengeType(stat.challengeType, isDisabled)}
                                    h={70}
                                    w={70}
                                />
                                <Text c="dark.2" size="0.625rem" fw={700}>
                                    {getBadgeText(stat.challengeType)}
                                </Text>
                                <Badge radius="xl" color="#F7EDFF14" c="primary.0">
                                    {isDisabled ? <Image src={Lock} h={12} w={12} /> : stat.successfulCount}
                                </Badge>
                            </Stack>
                        </Grid.Col>
                    );
                })}
        </Grid>
    );
}
